module.exports = __webpack_public_path__ + "img/checking.bf41bdad.svg";